import { useRef, useState, useEffect } from 'react';
import { Form, Modal, Row, Button as ButtonBootstrap } from 'react-bootstrap';
import CircleSign from './CircleSign';
import { ToastContainer, toast } from "react-toastify";
import { config } from "../../constants";

const url = config.url.URL;

const ForgotPass = ({openCloseForgotPassModal, successed,  showForgotPassModal}) => {

    const Email = useRef();
    const [emailVal, setEmailVal] = useState(true);
    const [textError, settextError] = useState("Required");

    const sendForgotPass = async () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (Email.current.value == ""){
        setEmailVal(false)
        settextError("Required");
        return;
      }else if(!emailRegex.test(Email.current.value)){
        setEmailVal(false)
        settextError("Please enter a valid email address");
        return;
      }
      else{
        setEmailVal(true)
      }

      const requestData = {
        email: Email.current.value
      };

      try {
          const response = await fetch(`${url}/login/RequestPassword`, {
              method: 'POST',
              headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
            },
              body: JSON.stringify(requestData)
          });

          var json = await response.clone().json();
          if (json.statusCode == 404){
            debugger
            settextError("Account does not exist, please contact your support.");
            setEmailVal(false)
            return;
            // toast.error("Account does not exist, please contact your support.");
          }
          else if(json.statusCode == 200){
            setEmailVal(true)
            toast.success(json.headers[0].value[0]);
            successed();
          }
          else{
            toast.error(json.headers[0].value[0]);
            console.log(json.headers[0].value[0]);
          }
      } catch (error) {
        toast.error("Your password could not be reset, please try again. In case of new failure, please contact your support.");
      }
    };

  return (
    <Modal
    show={showForgotPassModal}
    onHide={()=> {openCloseForgotPassModal(); setEmailVal(true)}}
    size="xs"
  >
    <Modal.Header closeButton>
      <Modal.Title size="h6">Reset password</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Form.Group className="mb-3 col-md-12" controlId="Email">
          <Form.Label  className={`${emailVal ? "normal-title" : "validation-title"} margin-bot-1`}>
            Please enter your email address <CircleSign />
          </Form.Label>
          <Form.Control
          className={`${!emailVal && "validation-control"}`}
            type="text"
            ref={Email}
            placeholder="Please enter your email address"
          />
          {!emailVal && <p className="p-required">{textError}</p>}
        </Form.Group>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <ButtonBootstrap
        variant="primary"
        className="btnPrimary"
        onClick={sendForgotPass}
      >
        Submit
      </ButtonBootstrap>
      <ButtonBootstrap
        variant="secondary"
        className="btnSecondary"
        onClick={()=> {openCloseForgotPassModal(); setEmailVal(true)}}
      >
        Cancel
      </ButtonBootstrap>
    </Modal.Footer>
  </Modal>
  )
}

export default ForgotPass